import * as apiUtils from '.'

const url = '/reconciliation'

export type DiscrepancyType =
  | 'MISSING_ORDER'
  | 'STATUS_MISMATCH'
  | 'LOCKED_NO_SERIAL'
  | 'LOCK_INCOMPLETE'
  | 'SERIAL_MISSING_IN_ERPNEXT'
  | 'BOM_MISSING_IN_ERPNEXT'

export interface Discrepancy {
  type: DiscrepancyType
  erpnextDocName?: string
  bcEntityId?: string
  expected?: string
  actual?: string
  actionable: boolean
  description: string
  timestamp: string
}

export type FixAction =
  | { type: 'LOCKED_NO_SERIAL'; cableId: string }
  | {
      type: 'STATUS_MISMATCH'
      bcEntityId: string
      direction: 'erpnext-to-bc' | 'bc-to-erpnext'
    }
  | { type: 'SERIAL_MISSING_IN_ERPNEXT'; cableId: string }
  | {
      type: 'RERUN_LOCK'
      cableIdentifier: string
      lookupBy: 'id' | 'serial'
      fromStep:
        | 'bc_split'
        | 'pending'
        | 'bom_submitted'
        | 'serials_created'
        | 'so_updated'
    }

export const getDiscrepancies = (): Promise<{
  discrepancies: Discrepancy[]
}> => apiUtils.GET(`${url}/discrepancies`)

export const checkSerials = (
  windowDays = 7,
): Promise<{ discrepancies: Discrepancy[] }> =>
  apiUtils.GET(`${url}/serial-check`, {
    params: { windowDays: String(windowDays) },
  })

export const fix = (
  action: FixAction,
): Promise<{ success: boolean; message: string }> =>
  apiUtils.POST(`${url}/fix`, action)
